export class CheckPointMasterPojo {

    checkPointId:number;
    checkPoint:string;
}